// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3my8s","location":"Header_location__SwTlz"};